import { useCallback, useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { ContractModalBody } from "./contractmodalbody";
import { initialState, reducer } from "./contractreducer";
import { getContract } from "../../../actions/contracts/contractget";
import { detailContractSelector } from "../../../reducers";
import LoadingCentered from "../../../common/loaders/loadingcentered";

export default function ContractModal({ contract, onCancel, onSave, checkPersonNumber, personNumberCheckResult, actionType, onFormErrors, setPdf }) {
  const reduxDispatch = useDispatch();
  const clearContractDetails = useCallback( () => reduxDispatch({type: "CLEAR_CONTRACT_DETAILS"}) );

  const detailContract = useSelector(detailContractSelector);

  const { t } = useTranslation();

  const [ state, dispatch ] = useReducer(reducer, initialState);

  useEffect(() => {
    if (contract != null && contract.contractId) {
      reduxDispatch(getContract(contract.contractId));
    }

    return clearContractDetails; // cleanup
  }, [contract]);

  useEffect(() => {
    if (contract != null && detailContract != null) {
      dispatch({type: "copy_for_editing", payload: detailContract});
    }
  }, [detailContract]);

  function handleSave() {
    onSave(state);
  }

  return state.company
    ? <ContractModalBody
      show
      state={state}
      dispatch={dispatch}
      title={t("NewContract", "Uusi työsopimus")}
      handleSave={handleSave}
      handleCancel={onCancel}
      checkPersonNumber={checkPersonNumber}
      personNumberCheckResult={personNumberCheckResult}
      actionType={actionType}
      onFormErrors={onFormErrors}
      setPdf={setPdf}
    />
    : <LoadingCentered show />;
}
